import { Injectable, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
export class TasksService {

  displayTasks: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  toogleDisplayTasks(){
    this.displayTasks.next(!this.displayTasks.value);
    return this.displayTasks.value;
  }

  open():void{
    if(this.displayTasks.value === false){
      this.toogleDisplayTasks();
    }
  }
}

(<any>window).tasksService = new TasksService();